const INCIDENT_TYPES = [
  {
    icon: 'ri-shield-keyhole-line',
    title: 'Authentication Failures',
    desc: 'Token expiry, invalid credentials, OAuth failures, and identity provider outages that break login flows.',
  },
  {
    icon: 'ri-plug-line',
    title: 'Dependency Outages',
    desc: 'Downstream APIs, payment gateways, or microservices becoming unavailable or degraded.',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Retry Storms',
    desc: 'Poor retry strategies triggering cascading traffic spikes that overwhelm services.',
  },
  {
    icon: 'ri-database-2-line',
    title: 'Database Exhaustion',
    desc: 'Connection pools, slow queries, or locked tables causing application timeouts.',
  },
  {
    icon: 'ri-speed-up-line',
    title: 'Rate Limiting',
    desc: 'APIs returning 429 responses due to traffic bursts or misconfigured throttling.',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Configuration Errors',
    desc: 'Incorrect environment variables, feature flags, or service settings causing outages.',
  },
];

export default function IncidentTypesSection() {
  return (
    <section className="py-24 border-t border-border-subtle">
      <div className="max-w-7xl mx-auto px-4 md:px-6">

        <div className="text-center mb-14">
          <div className="inline-block text-xs font-mono uppercase tracking-widest text-accent mb-3">
            Incident Patterns
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-text-primary">
            Incident Types You Will See
          </h2>

          <p className="text-text-secondary mt-3 max-w-2xl mx-auto text-sm leading-relaxed">
            Each challenge is based on real production failure patterns engineers encounter in distributed systems.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {INCIDENT_TYPES.map((item) => (
            <div
              key={item.title}
              className="bg-bg-panel border border-border-subtle rounded-xl p-6 hover:border-accent/30 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg border border-accent/30 bg-accent/5 text-accent mb-4">
                <i className={`${item.icon} text-xl`} />
              </div>

              <h3 className="text-lg font-semibold text-text-primary mb-2">
                {item.title}
              </h3>

              <p className="text-sm text-text-secondary leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-bg-panel border border-accent/20 rounded-2xl p-6 md:p-8">
          <p className="text-sm text-text-secondary text-center max-w-3xl mx-auto leading-relaxed">
            These patterns appear repeatedly across real systems.<br />
            Recognising them quickly is one of the most valuable skills for SREs and DevOps engineers — and exactly what the daily challenges are designed to train.
          </p>
        </div>

      </div>
    </section>
  );
}